import type { PlanKey } from './types'

// Shared between Register.tsx (plan selector), RegisterBilling.tsx, and
// the marketing Pricing page, so the three can't drift apart.
//
// Pricing position signed off 2026-10-11 (see the vault's
// Projects/remind-loop-pricing.md): Starter R149 / Business R299 /
// Scale R699, each with an active-debtor-account allowance AND a pooled
// WhatsApp+SMS message bundle. Early adopters (the first 25 customers) get
// 40% off any plan for 12 months. price/includedAccounts/overageRate/
// includedMessages below are marketing-copy literals matching the seeded
// DebtorAccountPlan/SubscriptionPlanPricing values exactly (migration
// e5b8d2a7c1f4); they are NOT read from a live endpoint. Prices are what
// the customer pays -- no VAT is added on top.
export const MESSAGE_OVERAGE_RATE = 0.35
export const EARLY_ADOPTER_DISCOUNT_PERCENT = 40
export const EARLY_ADOPTER_CAP = 25
export const EARLY_ADOPTER_MONTHS = 12
export const TRIAL_DAYS = 14

export const PLAN_OPTIONS: {
  value: PlanKey
  label: string
  hint: string
  price: number
  earlyAdopterPrice: number
  includedAccounts: number
  overageRate: number
  includedMessages: number
}[] = [
  {
    value: 'starter',
    label: 'Starter',
    hint: 'For a business chasing its own customers',
    price: 149,
    earlyAdopterPrice: 89,
    includedAccounts: 25,
    overageRate: 6,
    includedMessages: 100,
  },
  {
    value: 'business',
    label: 'Business',
    hint: 'For growing customer lists and small teams',
    price: 299,
    earlyAdopterPrice: 179,
    includedAccounts: 100,
    overageRate: 4,
    includedMessages: 400,
  },
  {
    value: 'scale',
    label: 'Scale',
    hint: 'For large customer lists and bigger teams',
    price: 699,
    earlyAdopterPrice: 419,
    includedAccounts: 500,
    overageRate: 2,
    includedMessages: 1500,
  },
]

export function isPlanKey(value: string): value is PlanKey {
  return PLAN_OPTIONS.some((option) => option.value === value)
}

// Waitlist gate for public launch (built 2026-09-19, see TODO.md's
// "Waitlist gate for public launch" section). When true, Pricing.tsx and
// Home.tsx's "Get started" CTAs open a waitlist form instead of linking
// to /register?plan={tier} -- /register itself stays completely
// unchanged and reachable directly, this only gates the marketing CTAs.
// Decision 2026-10-09: ALL marketing CTAs go to the waitlist for now, and
// /register is invite-only (token link from /admin/waitlist -- see
// Register.tsx and the backend's routes_invites.py). Flip to false only
// when public self-sign-up opens, together with the backend's
// INVITE_ONLY setting.
export const WAITLIST_MODE = true
